"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gendersList = void 0;
exports.gendersList = [
    {
        label: "Female",
        value: "Female",
    },
    {
        label: "Male",
        value: "Male",
    },
    {
        label: "Unknown",
        value: "Unknown",
    },
    {
        label: "Another gender",
        value: "Unspecified",
    },
];
